import { fetchRelogLink, RelogContractorLinkDto } from 'api/relog';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

const Relog = () => {
    const [hasError, setHasError] = useState(false);
    const [contractorLink, setContractorLink] = useState<RelogContractorLinkDto | null>(null);
    const { enqueueSnackbar } = useSnackbar();
    const { userName, branch } = useSelector((state: RootState) => state.userInfo);

    const getRelogLink = async () => {
        try {
            const relogLink = await fetchRelogLink(userName, branch?.relog_api_key || '');
            setContractorLink(relogLink);
        } catch (error) {
            enqueueSnackbar(`Ошибка при получении данных из Relog: ${error}`, {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        getRelogLink();
    }, []);

    const handleError = () => {
        setHasError(true);
    };

    return (
        <div style={{ width: '100%', height: '100%' }}>
            {hasError || !contractorLink?.contractorLink ? (
                <div>Ошибка загрузки iframe</div>
            ) : (
                <iframe
                    src={contractorLink?.contractorLink}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title="Relog"
                    onError={handleError}
                />
            )}
        </div>
    );
};

export default Relog;